module.exports = __webpack_public_path__ + "img/certificationreport.ac93e0d4.svg";